<div class="px-4">
    <div class="flex flex-col">
        @for (file of selectedFiles; track file) {
            <app-selected-file
                [file]="file"
                [index]="$index"
                (delete)="deleteFileAtIndex($event)" />
        } @empty {
            <div
                class="w-1/2 cursor-pointer rounded bg-background flex flex-row items-center p-4"
                (click)="triggerInputClick()"
                (dragover)="$event.stopPropagation(); $event.preventDefault()"
                (drop)="$event.preventDefault(); onDrop($event)">
                <fa-icon
                    class="text-custom-extra-dark-grey"
                    size="2xl"
                    [icon]="['fas', 'arrow-down-to-line']" />
                <div class="flex flex-col ml-4 text-custom-extra-dark-grey">
                    <span class="text-base font-medium">{{
                        (dragAndDropType() === DragAndDropTypeEnum.DEPOSIT ? 'depositFile' : 'selectFileToImport')
                            | transloco
                    }}</span>
                    <span class="text-sm font-normal">{{ 'orDragHere' | transloco }}</span>
                </div>
            </div>
        }
        @if (dragAndDropType() === DragAndDropTypeEnum.DEPOSIT && depositCount() >= MAX_DEPOSITS_ON_FOLDER) {
            <div class="flex flex-row rounded items-center bg-orange-200 text-orange-800 w-1/2 mt-2 p-4">
                <fa-icon
                    size="2xl"
                    [icon]="['fas', 'triangle-exclamation']" />
                <div class="flex flex-col ml-4">
                    <span> {{ 'warningMaximumDepositsForFolder' | transloco }}</span>
                    <span>{{ 'willDeleteOldestDeposit' | transloco }}</span>
                </div>
            </div>
        }
        @if (status === DragDropStatusEnum.ERROR) {
            <div class="flex flex-row items-center bg-error-container text-red-800 w-1/2 mt-2 p-4">
                <fa-icon
                    size="2xl"
                    [icon]="['fas', 'triangle-exclamation']" />

                <span class="ml-4">
                    {{
                        dragAndDropType() === DragAndDropTypeEnum.DEPOSIT
                            ? ('depositFileErrorMessage'
                              | transloco
                                  : {
                                        acceptedExtensions: acceptedFileTypes(),
                                        maxFileAmount: maxFileAmount(),
                                    })
                            : ('selectFileToImport' | transloco)
                    }}
                </span>
            </div>
        }

        @if (status === DragDropStatusEnum.SIZE_ERROR && maxBytesSize()) {
            <div class="flex flex-row items-center bg-error-container text-red-800 w-1/2 mt-2 p-4">
                <fa-icon
                    size="2xl"
                    [icon]="['fas', 'triangle-exclamation']" />
                <span class="ml-4">
                    {{ 'importSizeExceeded' | transloco: { LIMIT: (maxBytesSize()! | byteFormat) } }}
                </span>
            </div>
        }
    </div>

    <input
        #fileInput
        class="hidden"
        type="file"
        [accept]="acceptedFileTypes()"
        [multiple]="maxFileAmount() > 1"
        (change)="onFilesInputUpload($event)" />
</div>
